import { render, staticRenderFns } from "./Zoho.vue?vue&type=template&id=29b4b02a&scoped=true"
import script from "./Zoho.vue?vue&type=script&lang=js"
export * from "./Zoho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b4b02a",
  null
  
)

export default component.exports